module.exports = __webpack_public_path__ + "img/covers-01.00270d8d.png";